import { combineReducers, type Reducer, type ReducersMapObject } from 'redux';

import { MODULE_NAME } from '../../constants';

import { reducer as articlesReducer, type State as ArticlesState } from './articles';
import { reducer as shareReducer, type State as ShareState } from './share';
import { reducer as socialReducer, type State as SocialState } from './social';

interface State {
    articles: ArticlesState;
    share: ShareState;
    social: SocialState;
}

const reducers: ReducersMapObject<State> = {
    articles: articlesReducer,
    share: shareReducer,
    social: socialReducer,
};

const reducer: Reducer<State> = combineReducers(reducers);

type StateWithArticleCore = {
    [MODULE_NAME]: State;
};

const getState = (state: StateWithArticleCore) => state[MODULE_NAME];

export type { StateWithArticleCore };
export { getState, reducer, State };
